import UsersAndCohortsQueryWrapper from "./UsersAndCohortsQueryWrapper";
export { metadataProps } from "./UsersAndCohortsQueryWrapper";
export default UsersAndCohortsQueryWrapper;
